import { createContext, useContext } from 'react';

import type { AppShellContextValue } from '@/types/layout';

/**
 * Context for AppShell state and actions
 */
export const AppShellContext = createContext<AppShellContextValue | null>(null);

/**
 * Hook to access AppShell context.
 * Must be used within an AppShell component.
 *
 * @throws Error if used outside of AppShell
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { breakpoint, toggleSidebar } = useAppShell();
 *   return <button onClick={toggleSidebar}>Toggle</button>;
 * }
 * ```
 */
export function useAppShell(): AppShellContextValue {
  const context = useContext(AppShellContext);

  if (!context) {
    throw new Error('useAppShell must be used within an AppShell component');
  }

  return context;
}
